import { render } from "./MdlDetallesArticulo.vue?vue&type=template&id=41f07d54&scoped=true"
import script from "./MdlDetallesArticulo.vue?vue&type=script&lang=js"
export * from "./MdlDetallesArticulo.vue?vue&type=script&lang=js"

import "./MdlDetallesArticulo.vue?vue&type=style&index=0&id=41f07d54&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f07d54"]])

export default __exports__